export const Text = {
  baseStyle: {
    color: 'grey.400',
    fontSize: '14px',
  },
  variants: {
    secondary: {
      color: 'grey.300',
      fontSize: '12px',
      fontWeight: 500,
    },
    smallHeader: {
      color: 'black',
      fontSize: '16px',
      fontWeight: 700,
    },
    headerSubText: {
      color: 'grey.400',
      fontSiz: '14px',
      fontWeight: 400,
    },
    error: {
      color: 'alert',
      fontSize: '12px',
      fontWeight: 500,
    },
  },
}
